import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-selfie-updated-popup',
  templateUrl: './selfie-updated-popup.component.html',
  styleUrls: ['./selfie-updated-popup.component.css']
})
export class SelfieUpdatedPopupComponent {
  @Input() eventName: string = '';
  @Input() isOpen: boolean = false;



    constructor(
      private router: Router) {
    
    }

    
  closePopup() {
    this.isOpen = false;
    this.router.navigateByUrl('/selfie-message');
  }
}